// removed by extract-text-webpack-plugin
module.exports = {"IdColumn":"IdColumn--tw2tE"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Columns/IdColumn/IdColumn.local.css
// module id = 962
// module chunks = 1